module.exports = __webpack_public_path__ + "img/IMG_3450_L_BlackMatted_MockedUp.81458bf4.jpg";